import client from './restaurant-client';

export const login = (data: any) => client.post('/login', data);

export const logOut = () => client.post('/logout');
